export default __webpack_public_path__ + "static/media/photo.4f77f8f3.JPG";